var _g, _path, _path2, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMapboxMarkerIconPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "marker",
    "data-name": "marker",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 48,
    viewBox: "0 0 20 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "mapbox-marker-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    cx: 10,
    cy: 27,
    rx: 9,
    ry: 5,
    fill: "#c4c4c4",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mask",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shadow-2",
    "data-name": "shadow",
    fill: "#bfbfbf",
    d: "M10,32c5,0,9-2.2,9-5s-4-5-9-5-9,2.2-9,5S5,32,10,32Z",
    fillRule: "evenodd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "color",
    fill: "#ee4e8b",
    stroke: "#b43b71",
    strokeWidth: 0.5,
    d: "M19.25,10.4a13.0663,13.0663,0,0,1-1.4607,5.2235,41.5281,41.5281,0,0,1-3.2459,5.5483c-1.1829,1.7369-2.3662,3.2784-3.2541,4.3859-.4438.5536-.8135.9984-1.0721,1.3046-.0844.1-.157.1852-.2164.2545-.06-.07-.1325-.1564-.2173-.2578-.2587-.3088-.6284-.7571-1.0723-1.3147-.8879-1.1154-2.0714-2.6664-3.2543-4.41a42.2677,42.2677,0,0,1-3.2463-5.5535A12.978,12.978,0,0,1,.75,10.4,9.4659,9.4659,0,0,1,10,.75,9.4659,9.4659,0,0,1,19.25,10.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "circle",
    fill: "#fff",
    stroke: "#b43b71",
    strokeWidth: 0.5,
    d: "M13.55,10A3.55,3.55,0,1,1,10,6.45,3.5484,3.5484,0,0,1,13.55,10Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 48,
    fill: "none"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapboxMarkerIconPink);
export default __webpack_public_path__ + "static/media/mapbox-marker-icon-pink.fc3f136a053d28327370f3b8775e5a4c.svg";
export { ForwardRef as ReactComponent };